import { sessionLanguageMapping } from "pages/private/AveFlow/AveFlow.util";

/**
 * Filtro para obtener incidencias de pista
 */
export function getMessagesHimResumen(el: any,icon:any,background:any,t:any) {
    let result=null;
      const messages=el?.Messages?.Message?.map((item: any, index: any) => {
        const sDate = new Date(item.sDate);
        const eDate = new Date(item.eDate);
        return{
        id:index,
        title:item.head?item.head:'',
        desc:item.text?item.text:'',
        sDate:sDate? `${t('literals.from')}${sDate.toLocaleDateString(sessionLanguageMapping(), { month: 'short', day: '2-digit', year:'numeric' })}, ${item.sTime}` :'',
        eDate:eDate? `${t('literals.until')}${eDate.toLocaleDateString(sessionLanguageMapping(), { month: 'short', day: '2-digit', year:'numeric' })}, ${item.eTime}` :''
      }
      })
      if(messages){
        result={
          numberIncidents:messages?.length,
          origin:el.Origin.name,
          tag:icon.toUpperCase()+" "+el.number,
          messages:messages,
          background:background
        }
      }
      return result
    }
    
    /**
     * Filtro para obtener incidencias de pista
     */
    export function getMessagesHimCard(el: any) {
      let suma=0
      el.LegList.Leg?.map((element:any)=> {
        if(element?.Messages?.Message!=undefined){
          suma+=element?.Messages?.Message.length
        }
     
       }); 
        return suma
      }
    